import React from 'react';
import { Reveal } from './Reveal';
import { Countdown } from './Countdown';
export function Scarcity() {
  return <section className="w-full bg-black px-4 py-16" data-id="element-214">
      <Reveal className="mx-auto max-w-3xl rounded-3xl border border-gold/30 bg-ink-card p-8 text-center sm:p-12" data-id="element-215">
        <p className="text-sm font-bold uppercase tracking-widest text-gold" data-id="element-216">
          ⏰ Offre à durée limitée
        </p>
        <h2 className="mt-4 font-display text-2xl uppercase leading-tight text-white sm:text-3xl" data-id="element-217">
          Le prix de lancement se termine dans :
        </h2>

        <div className="mt-8" data-id="element-218">
          <Countdown data-id="element-219" />
        </div>

        <p className="mt-8 text-sm text-white/60" data-id="element-220">
          Après cela, le prix augmente et les outils complémentaires sont
          retirés.
        </p>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-sm font-semibold text-white/70" data-id="element-221">
          <span className="text-red-400" data-id="element-222">🔴 Places limitées</span>
          <span data-id="element-223">72% ont confirmé</span>
          <span data-id="element-224">Offre à durée limitée</span>
        </div>
        <p className="mt-4 text-sm text-white/50" data-id="element-225">
          Tout inclus, pour un prix unique. Pack complet. Sans ventes
          additionnelles. Sans surprises.
        </p>
      </Reveal>
    </section>;
}